export default __webpack_public_path__ + "static/media/checkbox-usage-search.be37765c.svg";